import { Button, ButtonProps } from 'antd';
import * as React from 'react';

export interface IBaseButtonProps {
  type: 'primary';
  text?: string;
  children?: JSX.Element;
  gradient?: boolean;
}

export interface IBaseButtonChildrenProps {
  title?: string;
}

export default function BaseButton(props: ButtonProps & IBaseButtonProps) {
  const { className, gradient, ...restProps } = props;

  return (
    <Button
      className={
        ` ${
          gradient ? 'bg-gradient-1 text-white' : 'bg-gray-2 text-opacity-60 text-violet-14 font-bold'
        } font-bold rounded-lg ` + className
      }
      htmlType="submit"
      {...restProps}
    >
      {props.text || props.children}
    </Button>
  );
}

BaseButton.Primary = (props: ButtonProps & IBaseButtonChildrenProps) => {
  const { className, ...restProps } = props;
  return (
    <Button htmlType="submit" className={'bg-gradient-1 text-white font-bold rounded-lg ' + className} {...restProps}>
      {props.title || props.children}
    </Button>
  );
};
